import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  TCampaign,
  TCampaignCreatePayload,
  TCampaignError,
} from '~/features/campaigns/models'
import { queryKeys } from '~/features/campaigns/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { sessionStore } from '~/store'

export const createCampaign = async (payload: TCampaignCreatePayload) => {
  return HttpService.post<TCampaign | TCampaignError>(
    {
      path: EServerPath.campaigns,
      payload,
    },
    EHttpService.internal,
  ).then((res) => {
    return res.data ? res.data : res
  })
}
const useCreateCampaign = () => {
  const queryClient = useQueryClient()
  const agentId = sessionStore((state) => state.agent.id) || ''

  return useMutation({
    mutationFn: (payload: TCampaignCreatePayload) => createCampaign(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.campaignsBase(agentId),
      })
    },
  })
}

export default useCreateCampaign
